import { Component, Input, OnInit } from '@angular/core';
import { CompanyParamsService } from '../../../core/services/company-params.service';

@Component({
  selector: 'app-loading-spinner',
  templateUrl: './loading-spinner.component.html',
  styleUrls: ['./loading-spinner.component.scss'],
})
export class LoadingSpinnerComponent implements OnInit {
  valueColor = '';
  constructor(private companyParamsService: CompanyParamsService) {}

  ngOnInit(): void {
    this.valueColor = `#${this.companyParamsService.getMainColor()}`;
    this.setColor()
  }
  setColor() {
    let box = document.getElementById('box');
    if (box) box.style.setProperty('--boxAfterBackColor', this.valueColor);
  }
}
